import React from "react";
import { Container } from "@mui/material";

export const Footer = () => {
  return (
    <>
      <footer>
        <Container>
          <p className="copyright">
            © Copyright 2021 by Diana Zayats. All Rights Reserved.
          </p>
        </Container>
      </footer>
    </>
  );
};
